module.exports = __webpack_public_path__ + "img/icon-survey-banner.cc94d46e.svg";